module.exports = __webpack_public_path__ + "img/P18F.ab738c47.png";